import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const legacyPortfolioPagesRoute: InvariantRoute = {
	name: 'legacy-portfolio-pages',
	path: '/secure/PortfolioPlan(\\w+).jspa',
};
